import { QueryClient } from '@tanstack/react-query';

import { SIX_HOURS_IN_MILLISECONDS } from '@/constants/common';
import { useGetMagazineRelatedMagazinesQuery } from '@/hooks/magazine/magazine.gql.impl';
import { parseRelatedMagazines } from '@/parsers/Communication/magazine';

const useGetRelatedFaq = (faqPid: string) => {
  const { data: relatedFaq } = useGetMagazineRelatedMagazinesQuery(
    {
      request: {
        size: 4,
        magazinePid: faqPid,
      },
    },
    {
      select: parseRelatedMagazines,
      staleTime: SIX_HOURS_IN_MILLISECONDS,
      cacheTime: SIX_HOURS_IN_MILLISECONDS,
    }
  );

  return {
    relatedFaq,
  };
};

export default useGetRelatedFaq;

useGetRelatedFaq.getKey = (faqPid: string) => {
  return useGetMagazineRelatedMagazinesQuery.getKey({
    request: {
      size: 4,
      magazinePid: faqPid,
    },
  });
};

useGetRelatedFaq.prefetchQuery = async (queryClient: QueryClient, faqPid: string) => {
  await queryClient.prefetchQuery(
    useGetMagazineRelatedMagazinesQuery.getKey({
      request: {
        size: 4,
        magazinePid: faqPid,
      },
    }),
    useGetMagazineRelatedMagazinesQuery.fetcher({
      request: {
        size: 4,
        magazinePid: faqPid,
      },
    })
  );
};
